import { useState } from 'react'

import { TuneOutlined } from '@mui/icons-material'
import { FormControlLabel, FormGroup, Menu } from '@mui/material'

import { AnswerStatusFilterOptions } from '@tabeeb/enums'
import { useDispatch, useSelector } from '@tabeeb/store'
import { Button, Checkbox, IconButton, Stack, Subheader2, usePopoverState } from '@collaborate-health/uikit'

import { getFormAnswerStatusFilter } from '@tabeeb/modules/forms/selectors'
import { setAnswerStatusFilter } from '@tabeeb/modules/forms/actions'

const AnswerStatusFilter = () => {
  const dispatch = useDispatch()
  const selectedFilterOptions = useSelector(getFormAnswerStatusFilter)

  const [selectedOptions, setSelectedOptions] = useState(selectedFilterOptions)

  const [anchorRef, open, onOpen, onClose] = usePopoverState<HTMLButtonElement>()

  const values = Object.values(AnswerStatusFilterOptions)
  const allSelected = selectedOptions.length === values.length

  const handleFilterMenuClose = () => {
    onClose()
    setSelectedOptions(selectedFilterOptions)
  }

  const handleFilterOptionClick = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value, checked } = e.target

    if (checked) {
      setSelectedOptions([...selectedOptions, value])
    } else {
      setSelectedOptions(selectedOptions.filter((o) => o !== value))
    }
  }

  const handleSelectAll = () => {
    if (allSelected) {
      setSelectedOptions([])
    } else {
      setSelectedOptions(values)
    }
  }

  const handleApply = () => {
    dispatch(setAnswerStatusFilter(selectedOptions))
    onClose()
  }

  return (
    <>
      <span>
        <Stack m={-0.5}>
          <IconButton ref={anchorRef} size='small' onClick={onOpen} color={allSelected ? undefined : 'primary'}>
            <TuneOutlined />
          </IconButton>
        </Stack>
      </span>

      <Menu
        anchorEl={anchorRef.current}
        open={open}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        onClose={handleFilterMenuClose}
      >
        <Stack paddingInline={1} width={240} spacing={1}>
          <Stack direction='row' alignItems='center' justifyContent='space-between'>
            <Subheader2>Status</Subheader2>
            <Button size='small' color='primary' onClick={handleSelectAll}>
              {allSelected ? 'Unselect all' : 'Select all'}
            </Button>
          </Stack>

          <FormGroup>
            {Object.values(AnswerStatusFilterOptions).map((option) => {
              const checked = selectedOptions && selectedOptions.includes(option)

              return (
                <FormControlLabel
                  key={option}
                  label={option}
                  sx={{ ml: -0.75 }}
                  control={
                    <Checkbox checked={checked} onChange={handleFilterOptionClick} value={option} color='primary' />
                  }
                />
              )
            })}
          </FormGroup>

          <Button variant='contained' color='primary' size='small' fullWidth onClick={handleApply}>
            Apply
          </Button>
        </Stack>
      </Menu>
    </>
  )
}

export default AnswerStatusFilter

